var Currency = {
  rates: {
    USD: 1,
    EUR: 1.09598,
    GBP: 1.26944,
    CAD: 0.744461,
    ARS: 0.00348447,
    AUD: 0.649994,
    BRL: 0.203829,
    CLP: 0.00116445,
    CNY: 0.1384,
    HKD: 0.127901,
    INR: 0.0120583,
    JPY: 0.00690184,
    MXN: 0.0588076,
    NZD: 0.598462,
    NOK: 0.0959285,
    PEN: 0.27029,
    SEK: 0.0926477,
    CHF: 1.1405,
    COP: 252369e-9,
    UYU: 0.0264532,
    ZAR: 0.0527802
    // puedes dejar todas o solo las que uses
  },

  convert: function (amount, from, to) {
    if (!this.rates[from] || !this.rates[to]) {
      console.warn('Currency missing:', from, to)
      return amount
    }
    return amount * this.rates[from] / this.rates[to]
  }
}
